export default "__VITE_ASSET__BcbYI$$O__$_?nuxt_component=async&nuxt_component_name=IconFooterPaymentMastercard&nuxt_component_export=default__"